import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PageCTA } from '../components/PageCTA';
import { Search, PenTool, Code2, Link as LinkIcon, Rocket, Sparkles, Map, CheckCircle2 } from 'lucide-react';
import { WireframeGlobe } from '../components/WireframeGlobe';
export function ProcessPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const steps = [{
    number: '01',
    title: 'Auditoría y Estrategia',
    description: 'Análisis profundo y hoja de ruta técnica diseñada para maximizar tu penetración en el mercado.',
    animation: <svg viewBox="0 0 64 64" className="w-16 h-16 mb-4" data-id="element-657">
          <motion.rect x="12" y="32" width="8" height="20" fill="#10b981" initial={{
        height: 0,
        y: 52
      }} whileInView={{
        height: 20,
        y: 32
      }} transition={{
        duration: 0.5
      }} data-id="element-658" />
          <motion.rect x="28" y="20" width="8" height="32" fill="#10b981" initial={{
        height: 0,
        y: 52
      }} whileInView={{
        height: 32,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-659" />
          <motion.rect x="44" y="8" width="8" height="44" fill="#10b981" initial={{
        height: 0,
        y: 52
      }} whileInView={{
        height: 44,
        y: 8
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-660" />
          <motion.circle cx="32" cy="32" r="16" fill="none" stroke="#fff" strokeWidth="2" initial={{
        scale: 0,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-661" />
          <motion.line x1="44" y1="44" x2="56" y2="56" stroke="#fff" strokeWidth="2" strokeLinecap="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.3,
        delay: 0.9
      }} data-id="element-662" />
        </svg>
  }, {
    number: '02',
    title: 'Diseño de Interfaces (UI/UX)',
    description: 'Arquitecturas visuales calculadas para reducir fricción y guiar al usuario hacia la conversión.',
    animation: <svg viewBox="0 0 64 64" className="w-16 h-16 mb-4" data-id="element-663">
          <motion.path d="M 10 54 L 54 10" stroke="#10b981" strokeWidth="4" strokeLinecap="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 1
      }} data-id="element-664" />
          <motion.path d="M 44 10 L 54 10 L 54 20" stroke="#10b981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} data-id="element-665" />
          <motion.circle cx="10" cy="54" r="4" fill="#fff" initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 1
      }} data-id="element-666" />
        </svg>
  }, {
    number: '03',
    title: 'Ingeniería y Desarrollo',
    description: 'Código limpio y escalable con frameworks modernos para tiempos de respuesta milisegundos.',
    animation: <svg viewBox="0 0 64 64" className="w-16 h-16 mb-4" data-id="element-667">
          <motion.path d="M 24 16 L 8 32 L 24 48" fill="none" stroke="#10b981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.6
      }} data-id="element-668" />
          <motion.path d="M 40 16 L 56 32 L 40 48" fill="none" stroke="#10b981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-669" />
          <motion.line x1="36" y1="12" x2="28" y2="52" stroke="#fff" strokeWidth="4" strokeLinecap="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-670" />
        </svg>
  }, {
    number: '04',
    title: 'Sincronización de Nodos',
    description: 'Interconectamos todas las plataformas para crear un flujo de datos ininterrumpido.',
    animation: <svg viewBox="0 0 64 64" className="w-16 h-16 mb-4" data-id="element-671">
          <motion.circle cx="32" cy="16" r="6" fill="#10b981" initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        type: 'spring'
      }} data-id="element-672" />
          <motion.circle cx="16" cy="48" r="6" fill="#10b981" initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        type: 'spring',
        delay: 0.2
      }} data-id="element-673" />
          <motion.circle cx="48" cy="48" r="6" fill="#10b981" initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        type: 'spring',
        delay: 0.4
      }} data-id="element-674" />
          <motion.line x1="32" y1="22" x2="16" y2="42" stroke="#fff" strokeWidth="2" strokeDasharray="4 4" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-675" />
          <motion.line x1="32" y1="22" x2="48" y2="42" stroke="#fff" strokeWidth="2" strokeDasharray="4 4" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} data-id="element-676" />
          <motion.line x1="16" y1="48" x2="48" y2="48" stroke="#fff" strokeWidth="2" strokeDasharray="4 4" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 1.0
      }} data-id="element-677" />
        </svg>
  }, {
    number: '05',
    title: 'Despliegue y Escalabilidad',
    description: 'Lanzamiento controlado con monitoreo en tiempo real. Maquinaria lista para operar.',
    animation: <svg viewBox="0 0 64 64" className="w-16 h-16 mb-4" data-id="element-678">
          <motion.path d="M 32 8 C 32 8 44 20 44 36 C 44 44 32 56 32 56 C 32 56 20 44 20 36 C 20 20 32 8 32 8 Z" fill="none" stroke="#10b981" strokeWidth="3" strokeLinejoin="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 1
      }} data-id="element-679" />
          <motion.path d="M 20 36 L 12 44 M 44 36 L 52 44" stroke="#10b981" strokeWidth="3" strokeLinecap="round" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} data-id="element-680" />
          <motion.circle cx="32" cy="28" r="4" fill="#fff" initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        delay: 1.2
      }} data-id="element-681" />
          <motion.line x1="32" y1="56" x2="32" y2="64" stroke="#fff" strokeWidth="2" strokeDasharray="2 2" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 1.5
      }} data-id="element-682" />
        </svg>
  }];
  const clientExperience = [{
    icon: <Code2 size={24} data-id="element-683" />,
    title: 'Abstracción de Complejidad',
    subtitle: 'Nosotros manejamos la ingeniería.'
  }, {
    icon: <Sparkles size={24} data-id="element-684" />,
    title: 'Gestión Integral',
    subtitle: 'Un único socio tecnológico.'
  }, {
    icon: <Map size={24} data-id="element-685" />,
    title: 'Trazabilidad Absoluta',
    subtitle: 'Visibilidad total sobre el progreso.'
  }, {
    icon: <CheckCircle2 size={24} data-id="element-686" />,
    title: 'Operatividad Inmediata',
    subtitle: 'Sistemas "Plug & Play".'
  }];
  const differentiators = [{
    title: 'Ingeniería orientada a Conversión',
    description: 'Interfaces basadas en datos para maximizar el LTV.',
    metric: '+120% LTV'
  }, {
    title: 'Arquitecturas Holísticas',
    description: 'Ecosistemas donde todo opera bajo una misma lógica.',
    metric: '100% Sincronizado'
  }, {
    title: 'Escalabilidad por Diseño',
    description: 'Patrones de software para soportar demanda exponencial.',
    metric: 'Cero Caídas'
  }, {
    title: 'Fricción Cero',
    description: 'Transiciones fluidas desde descubrimiento a transacción.',
    metric: '-40% Rebote'
  }, {
    title: 'Métricas que Importan',
    description: 'Éxito cuantificado en facturación y reducción de costos.',
    metric: 'ROI Medible'
  }];
  return <div className="pt-24" data-id="element-687">
      {/* Page Header */}
      <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-688">
        <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none" data-id="element-689"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-brand-emerald/15 blur-[120px] rounded-full pointer-events-none" data-id="element-690"></div>

        {/* Decorative Globe Background */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-30 pointer-events-none z-0" data-id="element-691">
          <WireframeGlobe size={400} data-id="element-692" />
        </div>

        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center max-w-4xl" data-id="element-693">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-694">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tighter" data-id="element-695">
              Cómo Transformamos Tu{' '}
              <span className="text-gradient" data-id="element-696">Negocio</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-400 leading-relaxed font-medium" data-id="element-697">
              Nuestra metodología está diseñada para llevar tu negocio al mundo
              digital de forma estructurada, profesional y sin dolores de cabeza
              para ti.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Process Timeline */}
      <section className="py-24 bg-[#050505] relative" data-id="element-698">
        <div className="section-divider absolute top-0" data-id="element-699"></div>
        <div className="absolute inset-0 bg-noise opacity-[0.02] mix-blend-overlay pointer-events-none" data-id="element-700"></div>

        <div className="container mx-auto px-6 md:px-12 max-w-5xl relative z-10" data-id="element-701">
          <div className="relative" data-id="element-702">
            {/* Vertical Line */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-brand-emerald/50 via-brand-emerald/20 to-transparent -translate-x-1/2 rounded-full" data-id="element-703"></div>

            <div className="space-y-12 md:space-y-24" data-id="element-704">
              {steps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6
            }} className={`flex flex-col md:flex-row items-center gap-8 md:gap-16 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-705">
                  {/* Content Card */}
                  <div className={`w-full md:w-1/2 ${index % 2 !== 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-706">
                    <div className="card-premium p-8 md:p-10 group relative overflow-hidden" data-id="element-707">
                      <div className={`absolute top-0 ${index % 2 !== 0 ? 'right-0' : 'left-0'} p-6 text-7xl font-black text-white/5 select-none pointer-events-none group-hover:text-brand-emerald/5 transition-colors`} data-id="element-708">
                        {step.number}
                      </div>

                      <div className={`flex flex-col ${index % 2 !== 0 ? 'items-start' : 'md:items-end items-start'} relative z-10`} data-id="element-709">
                        {step.animation}
                        <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight mb-4" data-id="element-710">
                          {step.title}
                        </h3>
                        <p className="text-gray-400 leading-relaxed font-medium text-base md:text-lg" data-id="element-711">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Center Node */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-16 h-16 rounded-full bg-[#0a0a0a] border-4 border-[#151515] items-center justify-center z-10 shadow-[0_0_30px_rgba(16,185,129,0.1)] group-hover:border-brand-emerald/30 group-hover:shadow-[0_0_40px_rgba(16,185,129,0.3)] transition-all duration-500" data-id="element-712">
                    <div className="w-5 h-5 rounded-full bg-brand-emerald/20 flex items-center justify-center group-hover:bg-brand-emerald/30 transition-colors duration-500" data-id="element-713">
                      <div className="w-2.5 h-2.5 rounded-full bg-brand-emerald shadow-[0_0_10px_rgba(16,185,129,0.8)] group-hover:shadow-[0_0_20px_rgba(16,185,129,1)] transition-shadow duration-500" data-id="element-714"></div>
                    </div>
                  </div>

                  {/* Empty space for alternating layout */}
                  <div className="hidden md:block w-1/2" data-id="element-715"></div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Client Experience */}
      <section className="py-24 bg-[#0a0a0a] relative" data-id="element-716">
        <div className="section-divider absolute top-0" data-id="element-717"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-718"></div>

        <div className="container mx-auto px-6 md:px-12 max-w-6xl relative z-10" data-id="element-719">
          <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-720">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-721">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 tracking-tighter" data-id="element-722">
                Diseñado para facilitarte{' '}
                <span className="text-gradient" data-id="element-723">todo</span>
              </h2>
              <p className="text-gray-400 text-xl font-medium" data-id="element-724">
                Sabemos que estás ocupado dirigiendo tu negocio. Nuestra
                experiencia de cliente está pensada para no quitarte tiempo.
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-725">
            {clientExperience.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gradient-to-br from-[#111] to-[#0a0a0a] border border-white/5 rounded-2xl p-6 flex items-center gap-6 group hover:border-brand-emerald/30 hover:shadow-[0_0_30px_rgba(16,185,129,0.1)] transition-all duration-500 shadow-lg" data-id="element-726">
                <div className="w-14 h-14 rounded-xl bg-brand-emerald/10 flex items-center justify-center text-brand-emerald shrink-0 border border-brand-emerald/20 group-hover:scale-110 transition-transform duration-500" data-id="element-727">
                  {point.icon}
                </div>
                <div className="flex-1" data-id="element-728">
                  <h3 className="text-lg font-bold text-white mb-1 tracking-tight" data-id="element-729">
                    {point.title}
                  </h3>
                  <p className="text-gray-400 font-medium text-sm" data-id="element-730">
                    {point.subtitle}
                  </p>
                </div>
                <div className="shrink-0 relative w-8 h-8" data-id="element-731">
                  <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90" data-id="element-732">
                    <circle cx="18" cy="18" r="16" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="3" data-id="element-733" />
                    <motion.circle initial={{
                  strokeDasharray: '0 100'
                }} whileInView={{
                  strokeDasharray: '100 100'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  delay: 0.5 + index * 0.1,
                  ease: 'easeOut'
                }} cx="18" cy="18" r="16" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" data-id="element-734" />
                  </svg>
                  <motion.div initial={{
                scale: 0,
                opacity: 0
              }} whileInView={{
                scale: 1,
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 1.5 + index * 0.1
              }} className="absolute inset-0 flex items-center justify-center" data-id="element-735">
                    <CheckCircle2 size={12} className="text-brand-emerald" data-id="element-736" />
                  </motion.div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Differentiation */}
      <section className="py-24 bg-[#050505] relative" data-id="element-737">
        <div className="section-divider absolute top-0" data-id="element-738"></div>
        <div className="absolute inset-0 bg-noise opacity-[0.02] mix-blend-overlay pointer-events-none" data-id="element-739"></div>

        <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10" data-id="element-740">
          <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start" data-id="element-741">
            <div className="w-full lg:w-1/3 sticky top-32" data-id="element-742">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} data-id="element-743">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 tracking-tighter" data-id="element-744">
                  Por qué Growthly es{' '}
                  <span className="text-gradient" data-id="element-745">diferente</span>
                </h2>
                <p className="text-gray-400 text-xl mb-8 font-medium" data-id="element-746">
                  Nos alejamos del modelo tradicional de agencia. No hacemos
                  "trabajos", construimos activos digitales para tu empresa.
                </p>
                <div className="hidden lg:block w-24 h-1 bg-gradient-to-r from-brand-emerald to-transparent rounded-full" data-id="element-747"></div>
              </motion.div>
            </div>

            <div className="w-full lg:w-2/3" data-id="element-748">
              <div className="space-y-6" data-id="element-749">
                {differentiators.map((point, index) => <motion.div key={index} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="group" data-id="element-750">
                    <div className="flex items-start gap-6 pb-6 border-b border-white/5 relative" data-id="element-751">
                      <div className="text-3xl font-black text-brand-emerald/30 group-hover:text-brand-emerald transition-colors shrink-0 mt-1" data-id="element-752">
                        0{index + 1}
                      </div>
                      <div className="flex-1" data-id="element-753">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2" data-id="element-754">
                          <h3 className="text-xl font-bold text-white tracking-tight" data-id="element-755">
                            {point.title}
                          </h3>
                          <span className="inline-flex items-center px-3 py-1 rounded-full bg-brand-emerald/10 border border-brand-emerald/20 text-brand-emerald text-xs font-bold uppercase tracking-widest shrink-0" data-id="element-756">
                            {point.metric}
                          </span>
                        </div>
                        <p className="text-gray-400 font-medium text-base" data-id="element-757">
                          {point.description}
                        </p>
                      </div>

                      {/* Animated bottom border */}
                      <motion.div className="absolute bottom-0 left-0 h-[1px] bg-brand-emerald" initial={{
                    width: 0
                  }} whileInView={{
                    width: '100%'
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.8,
                    delay: 0.3 + index * 0.1
                  }} data-id="element-758" />
                    </div>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <PageCTA data-id="element-759" />
    </div>;
}